// eslint-disable-next-line import/prefer-default-export
export const getSectionSettings = ({ baseId, sectionId, sectionSettings, baseTypeSettings }) => {
  if (baseTypeSettings[baseId] && baseTypeSettings[baseId].sectionSettings[sectionId]) {
    return baseTypeSettings[baseId].sectionSettings[sectionId];
  }

  return sectionSettings[sectionId] || {};
};
